<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Années début et fin saison</span>
      </div>
      <input :value="saison.annee_debut"
             name="saison_annee_debut"
             disabled
             type="text"
             class="form-control">
      <input :value="saison.annee_fin"
             name="saison_annee_fin"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select name="saison_championnat"
              disabled
              class="custom-select">
        <option>{{ (championnat && championnat.nom) ? championnat.nom : '' }}</option>
</select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Nombre de journées (Aller)</span>
      </div>
      <input :value="saison.nombre_journees_aller"
             name="nombre_journees_aller"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Nombre de journées (Retour)</span>
      </div>
      <input :value="saison.nombre_journees_retour"
             name="nombre_journees_retour"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="saison.date_creation"
             name="saison_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="saison.temps_creation"
             name="saison_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="saison.date_modification"
             name="saison_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="saison.temps_modification"
             name="saison_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    saison: {
      type: Object
    }
  },
  data(){
    return{
      championnat: null
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetOneData({
      table: "championnats",
      table_id: this.saison.championnat_id
    })
        .then( (data) => {
          this.championnat = data.data
        })
        .catch( (error) => {

        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/saisons/components/Read.vue